import React from 'react'
import fixIt from 'react-fix-it'
import {Provider} from 'react-redux'
import {StyleRoot} from 'radium'
import {withRadium} from 'higher-order-components'
import {childParser} from 'containers/utilities'
import getStore from 'store'
import './mjo.global.css'
// import './app.global.css'

const store = getStore()

/** Top Level Application Component.
 * Embedding the popup here could be unsafe but redux-saga dispatch control, and the fact that
 * the popup fires off a toast component which manages its own instances, should both mitigate
 * issues. KIV though, might have to embed the popup into a single page wrap in episerver.
 * */
class App extends React.PureComponent {
  /**
   * @param {Array} items - Array of Components.
   * @returns {ReactElement} React Component
   */
  render() {
    return (
      <Provider store={store}>
        <StyleRoot radiumConfig={{userAgent: 'all'}}>
          {childParser(this.props)}
        </StyleRoot>
      </Provider>
    )
  }
}

export default withRadium(fixIt)(App)



// WEBPACK FOOTER //
// ./src/containers/app/index.jsx